/* eslint-disable */
import api from "@/api";
import router from "@/router";
import {defineStore} from "pinia/dist/pinia";
import packageJson from "../../package.json";
import {useUserStore} from "@/stores/user";
import axios from 'axios';

const uploadBase = import.meta.env.VITE_UPLOAD_BASE_URL;

export const useUploadStore = defineStore('upload', {
  state: () => ({
    contentType: ''
  }),
  getters: {},
  actions: {
    async uploadFile(payload, { returnResponse = false } = {}) {
      const userStore = useUserStore();
      const url = `${uploadBase}/${payload.fileName}`;
      return await api.post(url, payload.file)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          console.log('uploadFile: ', data)
          if (data.response === 100) {
            return returnResponse ? { success: true, data } : true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          } else {
            userStore.errorMessage = data.message
            return false
          }
        })

    },
    async fetchContentType(url) {
      try {
        const response = await axios.head(url);
        this.contentType = response.headers['content-type'];
        return this.contentType
      } catch (error) {
        console.error('Error fetching content type:', error);
      }
    }
  },
})
